// @flow

/**
 * Converts ISO 3166-1 alpha-2 code to flag emoji.
 * Unicode emoji flags are rendered from pairs of Regional Indicator Symbols
 * representing the country code.
 */
export function getFlagEmoji(countryCode: ?string): string {
  if (!countryCode) return '';

  const codePoint = '🇦'.codePointAt(0);
  if (codePoint === undefined) return '';

  const offset = codePoint - 'A'.charCodeAt(0);
  return Array.from(countryCode.toUpperCase())
    .map((char: string) => String.fromCodePoint(char.charCodeAt(0) + offset))
    .join('');
}
